import React, { ReactElement } from "react";
import Content from "./Content";

export default function Li(props: any): ReactElement {
  return (
    <li>
      <Content contentValue={props.children} />
    </li>
  );
}
